import { PublicLayout } from '../layout/PublicLayout';
import { useSEO } from '@/hooks/useSEO';
import { LEGAL_CONFIG, LEGAL_ROUTES } from './legalConfig';
import { dmcaHtml } from './legalContent';

export const DmcaPage = () => {
  useSEO({
    title: `DMCA / Copyright Policy - ${LEGAL_CONFIG.companyName}`,
    description: `DMCA / Copyright Policy - ${LEGAL_CONFIG.companyName}`,
    keywords: 'dmca',
    ogTitle: `DMCA / Copyright Policy - ${LEGAL_CONFIG.companyName}`,
    ogDescription: `DMCA / Copyright Policy - ${LEGAL_CONFIG.companyName}`,
    ogType: 'website',
    canonicalUrl: `https://${LEGAL_CONFIG.domain}${LEGAL_ROUTES.dmca}`,
  });

  return (
    <PublicLayout>
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div
          className="prose prose-slate dark:prose-invert max-w-none space-y-8"
          dangerouslySetInnerHTML={{ __html: dmcaHtml }}
        />
      </article>
    </PublicLayout>
  );
};
